import { render, staticRenderFns } from "./chart8.vue?vue&type=template&id=6977cda4&scoped=true&"
import script from "./chart8.vue?vue&type=script&lang=js&"
export * from "./chart8.vue?vue&type=script&lang=js&"
import style0 from "./chart8.vue?vue&type=style&index=0&id=6977cda4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6977cda4",
  null
  
)

export default component.exports